import logo from '../../../assets/images/logo.png';
import { NAV_LINKS } from '../../../constants/homeData';
import { ROUTES } from '../../../constants/routes';
import { useAuthContext } from '../../../context/AuthContext';
import { useProfileContext } from '../../../context/ProfileContext';
import ProfileAvatar from '../../../components/common/ProfileAvatar';
import { getProfilePhotoUrl, mapProfileToForm } from '../../../utils/profileMappers';
import { Link, useNavigate } from 'react-router-dom';
import CoursesCategoryDropdown from './CoursesCategoryDropdown';
import HeaderSearch from './HeaderSearch';
import NotificationBell from './NotificationBell';

function HeaderSection() {
  const { isLoggedIn, openAuthPopup } = useAuthContext();
  const { user } = useProfileContext();
  const navigate = useNavigate();
  const profilePhoto = getProfilePhotoUrl(user);
  const profileName = mapProfileToForm(user)?.fullName?.trim() || 'Profile';

  return (
    <>
      <header className="fixed inset-x-0 top-0 z-50 bg-white">
        <div className="mx-auto flex max-w-7xl items-center px-4 py-2 sm:px-6 lg:px-8 lg:py-2 xl:px-10">
          <div className="flex min-w-0 items-center gap-5 lg:gap-10 xl:gap-14">
            <Link to="/" className="shrink-0">
              <img
                src={logo}
                alt="CHSE express"
                className="h-12 w-auto sm:h-14 xl:h-[70px] xl:w-[120px]"
              />
            </Link>

            <HeaderSearch />
          </div>

          <div className="ml-auto flex items-center gap-5 lg:gap-8 xl:gap-10">
            <nav className="hidden items-center gap-5 text-sm font-medium text-[#1B1B1B] md:flex lg:gap-6 lg:text-[15px] xl:gap-6 xl:text-[20px]">
              {NAV_LINKS.map(({ label, href, isRoute, hasCategoryDropdown }) => {
                if (hasCategoryDropdown) {
                  return <CoursesCategoryDropdown key={label} />;
                }

                if (isRoute) {
                  return (
                    <Link key={label} to={href} className="whitespace-nowrap transition-colors hover:text-[#9369CC]">
                      {label}
                    </Link>
                  );
                }

                return (
                  <a key={label} href={href} className="whitespace-nowrap transition-colors hover:text-[#9369CC]">
                    {label}
                  </a>
                );
              })}
            </nav>

            {isLoggedIn ? (
              <>
                <NotificationBell />
                <button
                  type="button"
                  onClick={() => navigate(ROUTES.PROFILE)}
                  className="shrink-0 rounded-full"
                  aria-label="Profile"
                >
                  <ProfileAvatar
                    src={profilePhoto}
                    alt={profileName}
                    className="h-11 w-11 rounded-full object-cover ring-2 ring-white sm:h-12 sm:w-12 xl:h-[60px] xl:w-[60px]"
                    iconClassName="h-6 w-6 text-white xl:h-7 xl:w-7"
                  />
                </button>
              </>
            ) : (
              <button
                type="button"
                onClick={openAuthPopup}
                className="whitespace-nowrap rounded-xl bg-gradient-to-t from-[#6A74E1] to-[#B539FD] px-4 py-2 text-sm font-bold text-white shadow sm:px-6 sm:text-base"
              >
                Login / Signup
              </button>
            )}
          </div>
        </div>
      </header>
      <div className="h-[70px] sm:h-[75px] lg:h-[78px] xl:h-[88px]" aria-hidden />
    </>
  );
}

export default HeaderSection;
